import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "../lib/apiClient";
import type { AdsbTarget } from "../map/types";
import type { AirTrack } from "../routes/(protected)/map/skopa/-features/types";
import type { TargetData } from "../routes/(protected)/map/skopa/-features/SkopaTargetList";

type Status = "pending" | "accepted" | "rejected" | "aborted" | "destroyed";

export type InterceptQuery = {
  status: Status;
  payload: TargetData;
};

type SkopaInterceptResult = {
  intercept_id: number;
  status: string;
  payload: unknown;
};

type SkopaInterceptQuery = {
  track_id: string;
  status: Status;
  intercepts: unknown[];
};

type SkopaQuery = {
  id: string;
  track_id: string;
  created_at: string;
};

export const useSkopaAllIntercept = () => {
  return useQuery({
    queryKey: ["skopa-intercept"],
    queryFn: (): Promise<SkopaQuery[]> => fetcher(`/api/skopa/intercept/all`),
  });
};

export const deleteSkopaIntercept = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetcher("/api/skopa/intercept", {
        method: "DELETE",
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["skopa-intercept"] }),
  });
};

export const useSkopaIntercept = () => {
  return useQuery({
    queryKey: ["skopa-intercept"],
    queryFn: (): Promise<SkopaInterceptQuery[]> =>
      fetcher(`/api/skopa/intercept`),
  });
};

export function addSkopaIntercept() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: InterceptQuery): Promise<SkopaInterceptResult> =>
      fetcher("/api/skopa/intercept", {
        method: "POST",
        body: JSON.stringify(data),
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["skopa-intercept"] }),
  });
}
